import { render, staticRenderFns } from "./EventDetection.vue?vue&type=template&id=84aad6d0"
import script from "./EventDetection.vue?vue&type=script&lang=js"
export * from "./EventDetection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports